import React from 'react';

export const CandidateTimelineSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col items-start gap-4 w-full">
      {/* Header Section */}
      <div className="flex w-full items-center justify-between">
        <div className="h-6 bg-gray-200 rounded animate-pulse w-64"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-40"></div>
      </div>

      {/* Timeline Steps */}
      <div className="flex w-full flex-col items-start">
        {/* Step 1 */}
        <div className="flex w-full items-start gap-6 pb-8">
          {/* Step Icon & Connector */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="w-0.5 h-20 bg-gray-200 animate-pulse mt-2"></div>
          </div>

          {/* Step Content Box */}
          <div className="h-20 bg-gray-200 rounded animate-pulse flex-1"></div>

          {/* Attachments */}
          <div className="flex flex-col gap-2 w-48">
            <div className="w-full h-10 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex w-full items-start gap-6 pb-8">
          {/* Step Icon & Connector */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="w-0.5 h-20 bg-gray-200 animate-pulse mt-2"></div>
          </div>

          {/* Step Content Box */}
          <div className="h-20 bg-gray-200 rounded animate-pulse flex-1"></div>

          {/* Attachments */}
          <div className="flex flex-col gap-2 w-48">
            <div className="w-full h-10 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="flex w-full items-start gap-6 pb-8">
          {/* Step Icon & Connector */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="w-0.5 h-20 bg-gray-200 animate-pulse mt-2"></div>
          </div>

          {/* Step Content Box */}
          <div className="h-20 bg-gray-200 rounded animate-pulse flex-1"></div>

          {/* No Attachments - Placeholder */}
          <div className="w-48"></div>
        </div>

        {/* Step 4 (Last - No connector) */}
        <div className="flex w-full items-start gap-6">
          {/* Step Icon */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
          </div>

          {/* Step Content Box */}
          <div className="h-20 bg-gray-200 rounded animate-pulse flex-1"></div>

          {/* Attachments */}
          <div className="flex flex-col gap-2 w-48">
            <div className="w-full h-10 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
